export default "__VITE_ASSET__DBEaecqJ__"